<template>
  <div class="sidebar-wrapper">

    <!-- 创建简历 模块 -->
    <div class="create-cv-box">

      <!-- 新建简历 -->
      <div class="create-cv-btn create" @click="debounce(() => { triggerCreateCvFunc('template') }, 300)" data-growing-container data-growing-idx="303">
        <i class="iconfont iconxinjianjianli"></i>
        <span>新建简历</span>
      </div>

      <!-- 引入简历 -->
      <div class="create-cv-btn import" @click="debounce(() => { triggerCreateCvFunc('import') }, 300)" data-growing-container data-growing-idx="304">
        <i class="iconfont icondaorujianli"></i>
        <span>导入简历</span>
      </div>

    </div>

    <!-- 在线简历 模块 -->
    <comp-online-cv :onlineCvData="onlineCvData"
                    :isUpdated="isUpdated"
                    :isPerfect="isPerfect"
                    :isStudent="isStudent"
                    :cvInvisibileVisible="cvInvisibileVisible"
                    :createOnlineCvVisible="createOnlineCvVisible"
                    :onlineCvModuleVisible="onlineCvModuleVisible"
                    @triggerCreateOnlineCvFunc="triggerCreateOnlineCvFunc"
                    @triggerUpdateOnlineCvFunc="triggerUpdateOnlineCvFunc"
                    @triggerToggleOnlineCvFunc="triggerToggleOnlineCvFunc"
                    @triggerShowOnlineCvDetailFunc="triggerShowOnlineCvDetailFunc" />

    <!-- tab 模块 -->
    <!-- 目前包含：1. 我的简历 2. 收藏模板 3. 回收站 -->
    <comp-tab-box :notSelectedMentorOrders="notSelectedMentorOrders"
                  :userLock="userLock"
                  @changeConfirmState="changeConfirmState"
                  @triggleCvUpdatedFunc="$emit('triggleCvUpdatedFunc')" />

    <!-- menu 模块 -->
    <comp-menu-box :skeletonContentTopVisible="skeletonContentTopVisible" @jobscanClickFunc="jobscanClickFunc" @planClickFunc="planClickFunc" />

    <!-- banner 模块 -->
    <div class="cvs-banner-box" v-if="banner.image" data-growing-container data-growing-idx="312">
      <img :src="banner.image" alt="" v-if="!banner.link">
      <a v-else :href="banner.link" target="_blank">
        <img :src="banner.image" alt="">
      </a>
    </div>

  </div>
</template>

<script>
import CompTabBox from '@/components/page/cvs/tab-box'
import CompMenuBox from '@/components/page/cvs/menu-box'
import CompOnlineCv from '@/components/page/cvs/online-cv'

import { componentsMixin } from '@/assets/js/mixins/components'

export default {
  props: {
    // 当前在线简历对应草稿简历是否有更新
    isUpdated: {
      type: Boolean,
      default: false
    },
    // 是否完善信息
    isPerfect: {
      type: Boolean,
      default: false
    },
    // 显示跳转到开启隐私按钮
    cvInvisibileVisible: {
      type: Boolean,
      default: false
    },
    // 显示创建在线简历入口
    createOnlineCvVisible: {
      type: Boolean,
      default: false
    },
    // 显示在线简历模块
    onlineCvModuleVisible: {
      type: Boolean,
      default: false
    },
    // 是否是学生
    isStudent: {
      type: Boolean,
      default: false
    },
    // 在线简历数据
    onlineCvData: {
      type: Object,
      default: {}
    },
    // 没有完善信息的导师订单数
    notSelectedMentorOrders: {
      type: Object,
      default: {
        count: 0
      }
    },
    skeletonContentTopVisible: {
      type: Boolean,
      default: false
    },
    // banner
    banner: {
      type: Object,
      default: {}
    },
    userLock: {
      type: Boolean,
      default: false
    }
  },
  mixins: [ componentsMixin ],
  data () {
    return {}
  },
  components: {
    CompTabBox, // tab 组件 目前包含：1. 我的简历 2. 收藏模板 3. 回收站
    CompMenuBox, // menu 组件
    CompOnlineCv, // 在线简历 组件
  },
  methods: {

    // 触发 简历创建
    triggerCreateCvFunc (val) {
      let alertData = {
        type: val,
        show: true
      }
      this.$store.dispatch('app/setAlertData', alertData)
    },
    // 触发 切换在线简历函数
    triggerToggleOnlineCvFunc () {
      this.$emit('triggerToggleOnlineCvFunc')
    },
    // 触发 创建在线简历函数
    triggerCreateOnlineCvFunc () {
      this.$emit('triggerCreateOnlineCvFunc')
    },
    // 触发 更新在线简历函数 
    triggerUpdateOnlineCvFunc () {
      this.$emit('triggerUpdateOnlineCvFunc')
    },
    // 触发 显示在线简历详情函数
    triggerShowOnlineCvDetailFunc () {
      this.$emit('triggerShowOnlineCvDetailFunc')
    },
    changeConfirmState (val) {
      this.$emit('changeConfirmState', val)
    },
    planClickFunc() {
      this.$emit('planClickFunc')
    },
    jobscanClickFunc() {
      this.$emit('jobscanClickFunc')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "./index.scss";
</style>
